/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressKitProfileListByCompanyIdResults,
    PressKitProfileListByCompanyIdResultsFromJSON,
    PressKitProfileListByCompanyIdResultsFromJSONTyped,
    PressKitProfileListByCompanyIdResultsToJSON,
} from './PressKitProfileListByCompanyIdResults';

/**
 * 企業のプレスキットのプロフィール一覧
 * @export
 * @interface PressKitProfileListByCompanyId
 */
export interface PressKitProfileListByCompanyId {
    /**
     * 企業のプレスキットのプロフィールの総数
     * @type {number}
     * @memberof PressKitProfileListByCompanyId
     */
    total: number;
    /**
     * プレスキットプロフィール一覧。仕様上は最大50件。
     * @type {Array<PressKitProfileListByCompanyIdResults>}
     * @memberof PressKitProfileListByCompanyId
     */
    results: Array<PressKitProfileListByCompanyIdResults>;
}

export function PressKitProfileListByCompanyIdFromJSON(json: any): PressKitProfileListByCompanyId {
    return PressKitProfileListByCompanyIdFromJSONTyped(json, false);
}

export function PressKitProfileListByCompanyIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressKitProfileListByCompanyId {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': json['total'],
        'results': ((json['results'] as Array<any>).map(PressKitProfileListByCompanyIdResultsFromJSON)),
    };
}

export function PressKitProfileListByCompanyIdToJSON(value?: PressKitProfileListByCompanyId | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': ((value.results as Array<any>).map(PressKitProfileListByCompanyIdResultsToJSON)),
    };
}

